<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import DatabaseHandler from "@/libs/indexedDB/database-handler";
import supervisorMW from "@/libs/middleware/supervisorMW";

export default {
  data(){
    return {
      session: {}
    }
  },
  beforeCreate() {
    let self = this;
    let userSession = JSON.parse(localStorage.userSession);

    if (userSession != null) {
      self.$store.commit("setUserSessionData", userSession);
      localStorage.removeItem("userSession");
    }
  },
  mounted() {
    window.addEventListener("unload", this.leaving);

    //#region Initialise Indexed DB
    let db = new DatabaseHandler();
    db.init("SuburbanServOfflineV3", 3)
      .then(result => {
        console.log("[INDEX DB] Successfully initialised");
      })
      .catch(error => {
        console.error(
          "[INDEX DB] FAILED TO INITIALISE",
          error,
          error.toString()
        );
      });
    //#endregion
  },
  methods: {
    leaving() {
      let userSession = this.$store.getters.getUserSessionData;

      localStorage.setItem("userSession", JSON.stringify(userSession));

      return null;
    }
  }
};
</script>

<style>
html,
body {
  overflow: auto;
}
</style>